import React from 'react';
import './sslogo.scss';
import LOGO from '../../assets/ss-logo.png';
export default function SSLogo({ salesStackRef }) {
  return (
    <div
      className="ss-logo"
      onClick={() => {
        if (salesStackRef) salesStackRef.current = true;
        window.location = '/';
      }}
    >
      <img src={LOGO} alt="logo" />
    </div>
  );
}
